import { render, staticRenderFns } from "./WebViewScoreboardOverrideForm.vue?vue&type=template&id=660c94b2&scoped=true"
import script from "./WebViewScoreboardOverrideForm.vue?vue&type=script&lang=js"
export * from "./WebViewScoreboardOverrideForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660c94b2",
  null
  
)

export default component.exports